'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { createDependentsPath } from 'DesignData/helpers/routingHelper';
import * as finderSelectors from 'DesignData/selectors/finder';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';

function makeMapStateToProps() {
  return function mapStateToProps(state, props) {
    const file = finderSelectors.getFile(state, props);
    return {
      dependentsPath: file && createDependentsPath(file.designAssetType, file.id)
    };
  };
}

const mapDispatchToProps = {};

class FileDependentsLink extends PureComponent {
  render() {
    const {
      children,
      dependentsPath,
      disabled,
      onClick
    } = this.props;
    return /*#__PURE__*/_jsx(UIRouterLink, {
      disabled: disabled || !dependentsPath || typeof onClick !== 'function',
      onClick: evt => {
        evt.stopPropagation();
        onClick(evt);
      },
      to: dependentsPath,
      children: children
    });
  }

}

FileDependentsLink.propTypes = {
  children: PropTypes.node.isRequired,
  dependentsPath: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
};
FileDependentsLink.defaultProps = {
  dependentsPath: ''
};
export default connect(makeMapStateToProps, mapDispatchToProps)(FileDependentsLink);